import { motion } from 'framer-motion';
import { User, Code, Mail, Github, Twitter, MapPin, Heart } from 'lucide-react';
import { siteConfig } from '../data';

export default function About() {
  return (
    <div className="min-h-screen pt-24 pb-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="flex items-center justify-center space-x-3 mb-4">
            <User className="text-pink-400" size={32} />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            关于
          </h1>
          <p className="text-xl text-pink-200/70">
            了解我和这个博客
          </p>
        </motion.div>

        {/* About Content */}
        <div className="space-y-8">
          {/* Profile Card */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="glass rounded-2xl p-8"
          >
            <div className="flex flex-col md:flex-row items-center md:items-start gap-6">
              <div className="w-32 h-32 rounded-full bg-gradient-to-br from-pink-400 via-purple-500 to-blue-500 flex items-center justify-center text-4xl font-bold text-white shadow-lg shadow-pink-500/30">
                {siteConfig.author.charAt(0).toUpperCase()}
              </div>
              <div className="text-center md:text-left">
                <h2 className="text-2xl font-bold text-white mb-2">
                  {siteConfig.author}
                </h2>
                <p className="text-pink-200/70 mb-4">技术爱好者 / 终身学习者</p>
                <div className="flex items-center justify-center md:justify-start space-x-4">
                  <a
                    href="https://github.com/shangbanlun"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-400 hover:text-pink-400 transition-colors"
                  >
                    <Github size={20} />
                  </a>
                  <a
                    href="https://twitter.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-400 hover:text-pink-400 transition-colors"
                  >
                    <Twitter size={20} />
                  </a>
                  <a
                    href="mailto:contact@shangbanlun.com"
                    className="text-gray-400 hover:text-pink-400 transition-colors"
                  >
                    <Mail size={20} />
                  </a>
                </div>
              </div>
            </div>
          </motion.div>

          {/* About Blog */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            viewport={{ once: true }}
            className="glass rounded-2xl p-8"
          >
            <div className="flex items-center space-x-3 mb-6">
              <Code className="text-purple-400" size={24} />
              <h3 className="text-xl font-bold text-white">关于这个博客</h3>
            </div>
            <div className="space-y-4 text-gray-300">
              <p>
                欢迎来到 {siteConfig.title}！这是一个使用现代技术栈构建的个人博客。
              </p>
              <p>
                博客的主要目的是分享技术学习笔记、记录生活点滴，同时也是练习写作和表达能力的平台。
              </p>
              <div className="mt-6">
                <h4 className="text-lg font-semibold text-white mb-3">技术栈</h4>
                <div className="flex flex-wrap gap-2">
                  {['React 18', 'TypeScript', 'Vite', 'Tailwind CSS', 'React Router', 'Framer Motion'].map(
                    (tech) => (
                      <span
                        key={tech}
                        className="px-3 py-1 text-sm bg-pink-500/20 text-pink-300 rounded-full border border-pink-500/30"
                      >
                        {tech}
                      </span>
                    )
                  )}
                </div>
              </div>
            </div>
          </motion.div>

          {/* Contact */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
            className="glass rounded-2xl p-8"
          >
            <div className="flex items-center space-x-3 mb-6">
              <Mail className="text-green-400" size={24} />
              <h3 className="text-xl font-bold text-white">联系方式</h3>
            </div>
            <div className="space-y-4">
              <p className="text-gray-300">
                如果您有任何问题、建议或合作意向，欢迎通过以下方式联系我：
              </p>
              <div className="flex items-center space-x-3 text-gray-300">
                <Mail size={18} className="text-pink-400" />
                <a
                  href="mailto:contact@shangbanlun.com"
                  className="hover:text-pink-400 transition-colors"
                >
                  contact@shangbanlun.com
                </a>
              </div>
              <div className="flex items-center space-x-3 text-gray-300">
                <MapPin size={18} className="text-pink-400" />
                <span>中国</span>
              </div>
            </div>
          </motion.div>

          {/* Thanks */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            viewport={{ once: true }}
            className="text-center py-8"
          >
            <p className="text-gray-400 flex items-center justify-center">
              感谢访问 <Heart size={16} className="mx-1 text-pink-500" /> 希望您有所收获
            </p>
          </motion.div>
        </div>
      </div>
    </div>
  );
}
